var APPEARANCE;
(function (APPEARANCE) {
    APPEARANCE["BREADCRUMBS"] = "breadcrumbs";
    APPEARANCE["DEFAULT"] = "default";
    APPEARANCE["NAVIGATION"] = "navigation";
    APPEARANCE["NAVIGATION_ANCHOR"] = "navigation-anchor";
    APPEARANCE["TITLE"] = "title";
})(APPEARANCE || (APPEARANCE = {}));
var SIZE;
(function (SIZE) {
    SIZE["ARTICLE"] = "article";
    SIZE["BODY"] = "body";
    SIZE["PARAGRAPH"] = "paragraph";
    SIZE["SMALL"] = "small";
    SIZE["TINY"] = "tiny";
    SIZE["TITLE01"] = "title-01";
    SIZE["TITLE02"] = "title-02";
})(SIZE || (SIZE = {}));

export { APPEARANCE, SIZE };
